const translations = {
  "en": {
    "and": "and",
    "Cancel anytime. No refunds for partial billing periods, except as required by applicable law. By subscribing, you agree to our": "Cancel anytime. No refunds for partial billing periods, except as required by applicable law. By subscribing, you agree to our",
    "Privacy Policy": "Privacy Policy",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "and": "和",
    "Cancel anytime. No refunds for partial billing periods, except as required by applicable law. By subscribing, you agree to our": "隨時取消。除適用法律要求外，已付費用恕不退還。訂閱即代表你同意我們的",
    "Privacy Policy": "隱私權政策",
    "Terms of Use": "使用條款"
  }
};

export default translations;
